/**
 * 根据名称获取公司信息请求参数
 */
export interface GetCompanyNameRequest {
    /** 返回结果数量 */
    n: number;
    /** 搜索关键词 */
    q: string;
    /** 搜索模式： family:同族库， publication:公开库 */
    search_mode: string;
    [property: string]: any;
}

export interface CompanyName {
    /** 日文名称 */
    jp_name: string;
    /** 韩文名称 */
    kr_name: string;
    /** 其他名称 */
    other_name: string;
    /** 英文名称 */
    en_name: string;
    /** 中文名称 */
    cn_name: string;
    /** 标准化中文名称 */
    nname_cn: string;
    /** 标准化英文名称 */
    nname_en: string;
    /** 标准化其他名称 */
    nname_other: string;
    /** 公司历史名称 */
    company_history_names: string[];
    /** 命中名称标签 */
    hit_name_tag: number;
}

/**
 * 公司建议信息
 */
export interface CompanyAutocompleteItemDTO extends CompanyName {
    /** 公司ID */
    company_id: string;
    /** 数量 */
    n: number;
}

/**
 * 根据名称获取公司信息响应
 */
export interface GetCompanyNameResponse {
    /** 找到的结果数量 */
    numFound: number;
    /** 公司建议列表 */
    suggest: CompanyAutocompleteItemDTO[];
    [property: string]: any;
}

export const GetCompanyNameApi = Symbol.for('GetCompanyNameApi');

/**
 * 根据名称获取公司信息 API
 */
export interface GetCompanyNameApi {
    /**
     * 根据名称获取公司信息
     * @param data 请求参数
     */
    getCompanyByName(data: GetCompanyNameRequest): Promise<GetCompanyNameResponse>;
}
